<template>
  <div class="loan-confirm pb-75px" v-if="loan">
    <div class="loan-confirm__xm loan-confirm__form-section">
      <div class="flex">
        <div class="label">금액</div>
        <div class="value" v-if="loan">{{loan.amount | toCurrency}} 원</div>
      </div>
      <div class="flex">
        <div class="label">
          이자율
        </div>
        <div class="value">
          연 {{getPercent(loan.offer.interest_rate)}}%
        </div>
      </div>
      <div class="flex">
        <div class="label">
          수수료
        </div>
        <div v-if="loan.offer.fee_rate" class="value">
          연 {{getPercent(loan.offer.fee_rate)}}%
        </div>
        <div v-else class="value">
          대출금액의 {{getPercent(loan.offer.commission_rate)}}%
        </div>
      </div>
      <div class="flex">
        <div class="label">
          입금<br/>
          예정일
        </div>
        <div class="value">
          {{loan.offer.scheduled_execution_date}}
        </div>
      </div>
    </div>
    <div class="loan-confirm__xm loan-confirm__confirm-section">
      <div class="agree-wrapper">
        <img
          @click="isAgreed = !isAgreed"
          v-if="isAgreed == true"
          src="../../assets/images/etc-checkbox-dn.png"
        />
        <img @click="isAgreed = !isAgreed" v-else src="../../assets/images/etc-checkbox.png" />
      </div>
      <div @click="isAgreed = !isAgreed">
        대출 금액, 기간, 이자율을 모두 확인하였으며
        <strong>{{loanTitle}} 대출 신청을 완료</strong>합니다.
      </div>
    </div>
    <div class="loan-confirm__btn-wrapper">
      <div
        class="loan-confirm__btn-wrapper__submit submit-block">
        <button v-ripple type="button" @click="complete" :disabled="isInProgress">
          제출하기
          <v-progress-circular
            style="padding-left: 15px;"
            size="24"
            v-if="isInProgress"
            indeterminate
            color="primary"/>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import LoanService from '@/service/loan/LoanService'
import StatusService from '@/service/status/StatusService'
import ContractService from '@/service/contract/ContractService'
// import userApi from '@/api/now/userApi'

import moment from 'moment'

import { mapGetters } from 'vuex'

import { setContext } from '@sentry/browser'

export default {
  name: 'LoanConfirm',
  data() {
    return {
      loanTitle: '비상금',
      loan: null,
      isInProgress: false,
      isAgreed: false,
    }
  },
  async created() {
    localStorage.removeItem('retries')

    for (const [key, value] of Object.entries(this.agreementData)) {
      if (key && value == null) {
        let swal = await this.reject('계약서 내용이 존재하지 않습니다')
        if (swal.isConfirmed) {
          this.$router.push({ name: 'documents/limittransaction' })
          return
        }
      }
    }

    this.loan = await LoanService.getCurrentLoan()
    if (this.loan && this.loan.type === 'marketing') {
      this.loanTitle = '마케팅론'
    } else if (this.loan && this.loan.type === 'second_mortgage') {
      this.loanTitle = '아파트론'
    }
    this.$store.commit('ui/headerTitle', this.loanTitle + ' 대출 접수')

    this.loan.offer.scheduled_execution_date = moment().format('YYYY/MM/DD')
  },
  computed: {
    ...mapGetters('loan', {
      agreementData: 'getAgreementData',
    })
  },
  methods: {
    reject(reason) {
      return this.$swal.fire({
        html: reason,
        icon: 'warning',
        confirmButtonText: '확인'
      })
    },
    async complete() {
      if (this.isInProgress) {
        return
      }

      if (!this.isAgreed) {
        let swal = await this.reject('"비상금 대출 신청 완료" 항목을 선택해주세요!')
        if (swal.isConfirmed) {
          return
        }
      }

      if (this.loan && this.loan.amount < 1) {
        let swal = await this.reject('심사 결과 비상금 신청이 어렵습니다.')
        if (swal.isConfirmed) {
          this.$router.push({ name: 'dashboard' })
          return
        }
      }

      try {
        this.isInProgress = true

        console.log(123456)
        let formData = new FormData()
        formData.append('contract', this.agreementData.contract)
        formData.append('term', this.agreementData.term)
        formData.append('offer', this.agreementData.offer)
        formData.append('is_agreed', this.agreementData.is_agreed)
        formData.append('signature', this.agreementData.signature, 'signiture.png')
        formData.append('image', this.agreementData.image, 'image.png')

        await ContractService.postAgreement(formData)
        await LoanService.executeFunding()
        await StatusService.syncStatus()
        this.$router.push({ name: 'dashboard' })
      } catch (e) {
        setContext('formData', this.agreementData)

        if (e.status === 400) {
          const errorMessage = e.data.message
          await this.$swal.fire({
            html: errorMessage,
            confirmButtonText: '확인',
            icon: 'warning',
            allowOutsideClick: false,
          })
          this.$router.push({ name: 'dashboard' })
          return
        }

        let result = await this.$swal.fire({
          html: '대출을 신청하는데 문제가 발생했습니다',
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: false,
          icon: 'warning',
          confirmButtonText: '재시도',
          cancelButtonText: '종료',
        })

        if (result.isDismissed) {
          this.$router.push({ name: 'dashboard' })
        } else if (result.isConfirmed) {
          const retries = parseInt(localStorage.getItem('retries')) || 0
          if (retries > 1) {
            localStorage.removeItem('retries')
            let swal = await this.$swal.fire({
              html: '대출 신청에 오류가 지속적으로 발생하여 신청이 종료됩니다. 고객센터로 문의주세요.',
              icon: 'warning',
              confirmButtonText: '확인'
            })
            if (swal.isConfirmed) {
              this.$router.push({ name: 'dashboard' })
              return
            }
          }
          localStorage.setItem('retries', retries + 1)
          this.isInProgress = false
          await this.complete()
        }
      }
    },
    getPercent(rate) {
      let interestRate = rate != null ? rate : 0
      return (interestRate * 100).toFixed(1)
    },
  }
}
</script>
<style lang="scss" scoped>
$fundablue: #1baaf1;
.loan-confirm {
  margin-top: 10px;
  strong {
    font-weight: 900;
  }
  &__xm {
    margin: 0 25px;
  }
  &__guide-section {
    background-color: #f4faff;
    padding: 16px 22px;
    font-size: 16px;
    border-radius: 8px;
    p {
      text-align: center;
      line-height: 24px;
      .blue {
        color: $fundablue;
      }
    }
  }
  &__form-section {
    margin-top: 20px;

    .flex:not(:last-child) {
      margin-bottom: 10px;
    }
    .flex {
      display: flex;
      font-weight: 700;
      align-items: center;
    }
    .label {
      font-size: 16px;
      line-height: 20px;
      flex: 1 1 71px;
      padding-right: 5%;
    }
    .value {
      word-break: keep-all;
      font-size: 18px;
      flex: 4 4 100px;
      padding: 14px;
      text-align: right;
      border: 1px solid #d7e1ea;
      border-radius: 4px;
    }
    .weak {
      font-weight: normal;
    }
  }
  &__confirm-section {
    margin-top: 20px;
    padding-bottom: 29px;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;

    .agree-wrapper {
      height: 24px;
      img {
        cursor: pointer;
        border-radius: 50%;
      }
    }
    div:nth-child(1) {
      padding-right: 11px;
    }
  }
  &__btn-wrapper {
    max-width: 42.5rem;
    width: 100%;
    height: 9.51%;
    min-height: 68px;
    position: fixed;
    bottom: 0;

    .submit-block {
      width: 100%;
      button {
        background-color: $fundablue;
      }
    }
    .submit-mini {
      width: 41.6%;
      button {
        background-color: #333333;
      }
    }
    button {
      padding: 0;
      height: 9.51%;
      float: left;
      text-decoration: none;
      z-index: 999;
      font-size: 20px;
      font-weight: 900;
      color: #ffffff;
    }
    &__submit {
      height: 100%;
      left: 0;
      float: left;
      button {
        width: 100%;
        height: 100%;
      }
    }
    &__subscription {
      height: 100%;
      line-height: 25px;
      width: 58.4%;
      float: left;
      button {
        background-color: $fundablue;
        width: 100%;
        height: 100%;
        .weak {
          font-weight: 700;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
